export function formatDate(date) {
    let data = new Date(date);
    let dia = data.getDate();
    dia = dia.toString();
    let diaF = (dia.length === 1) ? '0' + dia : dia

    let mes = (data.getMonth() + 1).toString() //+1 pois no getMonth Janeiro começa com zero.
    let mesF = (mes.length === 1) ? '0' + mes : mes
    let anoF = data.getFullYear();
    return diaF + "/" + mesF + "/" + anoF;
}

export function formatDateWithHours(date) {
    let data = new Date(date);
    let hours = data.getHours();
    let minutes = data.getMinutes();
    minutes = minutes < 10 ? '0' + minutes : minutes;
    let strTime = hours + ':' + minutes;
    return data.getDate() + "/" + (data.getMonth() + 1) + "/" + data.getFullYear() + "  " + strTime;
}

export function formatDateFilter(date) {
    if (date) {
        let data = new Date(date);
        let dia = data.getDate();
        dia = dia.toString();
        let diaF = (dia.length === 1) ? '0' + dia : dia
        let mes = (data.getMonth() + 1).toString() //+1 pois no getMonth Janeiro começa com zero.
        let mesF = (mes.length === 1) ? '0' + mes : mes
        let anoF = data.getFullYear();
        return diaF + "-" + mesF + "-" + anoF;
    }
    else {
        return null;
    }
}

export function formatDateFilterNew(date) {
    if (date) {
        let data = new Date(date);
        let dia = data.getDate();
        dia = dia.toString();
        let diaF = (dia.length === 1) ? '0' + dia : dia
        let mes = (data.getMonth() + 1).toString() //+1 pois no getMonth Janeiro começa com zero.
        let mesF = (mes.length === 1) ? '0' + mes : mes
        let anoF = data.getFullYear();
        return diaF + "-" + mesF + "-" + anoF;
    }
    else {
        return "";
    }
}

export function setDateFirst(start) {
    if (start === 1) {
        let data = new Date();
        let mes = (data.getMonth() + 1).toString() //+1 pois no getMonth Janeiro começa com zero.
        let anoF = data.getFullYear();
        let mesF = (mes.length === 1) ? '0' + mes : mes
        //let dataStart = new Date(mesF + "-" + '01' + "-" + anoF);
        let dataStart = `${new Date(`${mesF} - 01 - ${anoF}`)}`;
        return dataStart;
    } else {
        let dia;
        let data = new Date();
        let mes = (data.getMonth() + 1).toString() //+1 pois no getMonth Janeiro começa com zero.
        (parseFloat(mes) % 2 === 1) ? dia = '31' : dia = '30';
        let mesF = (mes.length === 1) ? '0' + mes : mes
        let anoF = data.getFullYear();
        let dataEnd = new Date(mesF + "-" + dia + "-" + anoF);
        return dataEnd;
    }
}